import { Component, Input, OnInit, OnChanges, ViewChild, Output, EventEmitter } from '@angular/core';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { JsonFormViewComponent } from '../../../core/json-form/material/json-form-view/json-form-view.component';

@Component({
   selector: 'app-nav-elem-detail',
   templateUrl: './nav-elem-detail-view.component.html',
   styleUrls: ['./nav-elem-detail-view.component.scss']
})
export class NavElemDetailComponent implements OnInit, OnChanges {

   // input
   @Input() public cancelButton = false;
   @Input() public submitButton = true;
   @Input() public elementDetail: any = null;
   @Input() public readonly = false;
   // child
   @ViewChild(JsonFormViewComponent) _jsonFormView: JsonFormViewComponent = null;
   // Output
   @Output() private submitEvent = new EventEmitter<any>();
   @Output() private cancelEvent = new EventEmitter();

   constructor() { }

   ngOnInit() {
   }

   ngOnChanges() {
      if (this._jsonFormView) {
         this._jsonFormView.resetContent();
      }
   }

   // ---------------------------------------------------------------------------------------------
   // -- Event Handler
   // ---------------------------------------------------------------------------------------------
   private onSubmit(formValue: any): void {
      this.submitEvent.emit(formValue);
   }

   private onApply(formValue: any): void {
      // not needed
   }

   private onCancel() {
      this.cancelEvent.emit();
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-elem-detail-view/nav-elem-detail-view.component.ts